// extracted by mini-css-extract-plugin
export var brand = "_1n-9";
export var button = "_1n-0";
export var chevron = "_1n-v";
export var chevronButton = "_1n-w";
export var content = "_1n-n";
export var danger = "_1n-g";
export var dangerOutlined = "_1n-h";
export var dark = "_1n-l";
export var darkTheme = "_1n-c";
export var extraSmall = "_1n-4";
export var fullWidth = "_1n-8";
export var ghost = "_1n-d";
export var gray = "_1n-t";
export var icon = "_1n-p";
export var iconButton = "_1n-s";
export var iconButtonBorder = "_1n-x";
export var iconButtonBorderDark = "_1n-y";
export var iconButtonBorderLight = "_1n-z";
export var iconLeft = "_1n-q";
export var iconRight = "_1n-r";
export var large = "_1n-1";
export var light = "_1n-m";
export var medium = "_1n-2";
export var micro = "_1n-5";
export var nano = "_1n-7";
export var outlined = "_1n-k";
export var pending = "_1n-a";
export var primary = "_1n-i";
export var shadow = "_1n-o";
export var small = "_1n-3";
export var solidLight = "_1n-e";
export var solidLightBrand = "_1n-f";
export var spinner = "_1n-u";
export var transparent = "_1n-j";
export var warning = "_1n-b";
export var wideNano = "_1n-6";